import {
  put, takeLatest, all, select, takeEvery,
} from 'redux-saga/effects';
import TrackerActions from '@Actions/trackerActions';
import { notification } from 'antd';
import JobWorkActions, { jobWorkActionTypes } from '@Actions/production/jobWorkActions';
import JobWorkServices from '../../services/production/jobWorkServices';
import { func } from 'joi';

/**
 * @param action
 */
function* _getJobWorks(action) {
  try {
    yield put(JobWorkActions.getJobWorksLoading(true));
    const { payload, callback } = action;
    const {
      orgId, tenantId, departmentId, status, moStatus, route, page, limit, searchKeyword, startDate, endDate, assignee, resourceId, resourceGroupId, sellerId, isListScreen,
    } = payload;
    const state = yield select();
    const isV2Enabled = state.UserReducers?.user?.tenant_info?.global_config?.settings?.enable_jw_v2;
    let jobWorks;
    if(isV2Enabled) {
      jobWorks = yield JobWorkServices.getJobWorksV2(orgId, tenantId, departmentId, status, moStatus, route, page, limit, searchKeyword, startDate, endDate, assignee, resourceId, resourceGroupId, sellerId, isListScreen);
    } else {
      jobWorks = yield JobWorkServices.getJobWorks(orgId, tenantId, departmentId, status, moStatus, route, page, limit, searchKeyword, startDate, endDate, assignee, resourceId, resourceGroupId, sellerId, isListScreen);
    }
    yield put(JobWorkActions.getJobWorksSuccess(jobWorks));
    yield put(JobWorkActions.getJobWorksLoading(false));
  } catch (error) {
    yield put(JobWorkActions.getJobWorksLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(jobWorkActionTypes.JOB_WORKS.ERROR, error));
  }
}

/**
 *
 */
function* getJobWorks() {
  yield takeLatest(jobWorkActionTypes.JOB_WORKS.REQUEST, _getJobWorks);
}

function* _getJobWorkById(action) {
  try {
    yield put(JobWorkActions.getJobWorkByIdLoading(true));
    const {
      payload, callback,
    } = action;
    const { tenantId, productionRouteLineId } = payload;
    const state = yield select();
    const isV2Enabled = state.UserReducers?.user?.tenant_info?.global_config?.settings?.enable_jw_v2;
    let jobWork;
    if(isV2Enabled) {
      jobWork = yield JobWorkServices.getJobWorkByIdV2(tenantId, productionRouteLineId);
    } else {
      jobWork = yield JobWorkServices.getJobWorkById(tenantId, productionRouteLineId);
    }
    if (jobWork?.success) {
      yield put(JobWorkActions.getJobWorkByIdSuccess(isV2Enabled ? jobWork?.job_works?.[0] : jobWork?.data?.job_works?.[0]));
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        placement: 'top',
        type: 'error',
        message: jobWork.message,
        duration: 4,
      });
    }
    yield put(JobWorkActions.getJobWorkByIdLoading(false));
  } catch (error) {
    yield put(JobWorkActions.getJobWorkByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* getJobWorkById() {
  yield takeLatest(jobWorkActionTypes.JOB_WORK_BY_ID.REQUEST, _getJobWorkById);
}

/**
 * @param action
 */
function* _getJobWorkByMoId(action) {
  try {
    yield put(JobWorkActions.getJobWorkByMoIdLoading(true));
    const {
      orgId, tenantId, moId, isListScreen,
    } = action;
    const state = yield select();
    const isV2Enabled = state.UserReducers?.user?.tenant_info?.global_config?.settings?.enable_jw_v2;
    let jobWork;
    if(isV2Enabled) {
      jobWork = yield JobWorkServices.getJobWorkByMoIdV2(orgId, tenantId, moId, isListScreen);
    } else {
      jobWork = yield JobWorkServices.getJobWorkByMoId(orgId, tenantId, moId, isListScreen);
    }
    
    yield put(JobWorkActions.getJobWorkByMoIdSuccess(isV2Enabled ? jobWork : jobWork?.data));
    yield put(JobWorkActions.getJobWorkByMoIdLoading(false));
  } catch (error) {
    yield put(JobWorkActions.getJobWorkByMoIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(jobWorkActionTypes.JOB_WORK_BY_MO_ID.ERROR, error));
  }
}

/**
 *
 */
function* getJobWorkByMoId() {
  yield takeLatest(jobWorkActionTypes.JOB_WORK_BY_MO_ID.REQUEST, _getJobWorkByMoId);
}

function* _updateJobWork(action) {
  try {
    yield put(JobWorkActions.updateJobWorkLoading(true));
    const {
      payload, callback,
    } = action;
    const updatedJobwork = yield JobWorkServices.updateJobWork(payload);
    if (updatedJobwork?.success) {
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        placement: 'top',
        duration: 4,
        message: updatedJobwork?.error,
        type: 'error',
      });
    }
    yield put(JobWorkActions.updateJobWorkLoading(false));
  } catch (error) {
    yield put(JobWorkActions.updateJobWorkLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(jobWorkActionTypes.UPDATE_JOB_WORK.ERROR, error));
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* updateJobWork() {
  yield takeLatest(jobWorkActionTypes.UPDATE_JOB_WORK.REQUEST, _updateJobWork);
}

function* _updateJobWorkV2(action) {
  try {
    yield put(JobWorkActions.updateJobWorkV2Loading(true));
    const {
      payload, callback,
    } = action;
    const updatedJobworkV2 = yield JobWorkServices.updateJobWorkV2(payload);
    if (updatedJobworkV2?.success) {
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        placement: 'top',
        duration: 4,
        message: updatedJobworkV2?.error,
        type: 'error',
      });
    }
    yield put(JobWorkActions.updateJobWorkV2Loading(false));
  } catch (error) {
    yield put(JobWorkActions.updateJobWorkV2Loading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(jobWorkActionTypes.UPDATE_JOB_WORK_V2.ERROR, error));
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* updateJobWorkV2() {
  yield takeLatest(jobWorkActionTypes.UPDATE_JOB_WORK_V2.REQUEST, _updateJobWorkV2);
}

function* _getJobOperators(action) {
  try {
    yield put(JobWorkActions.getJobOperatorsLoading(true));
    const {
      payload,
    } = action;
    const jobOperators = yield JobWorkServices.getJobOperators(payload?.orgId);
    yield put(JobWorkActions.getJobOperatorsSuccess(jobOperators?.data?.[0]?.users));
    yield put(JobWorkActions.getJobOperatorsLoading(false));
  } catch (error) {
    yield put(JobWorkActions.getJobWorkByMoIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(jobWorkActionTypes.JOB_WORK_BY_MO_ID.ERROR, error));
  }
}

function* getJobOperators() {
  yield takeLatest(jobWorkActionTypes.GET_JOB_OPERATORS.REQUEST, _getJobOperators);
}

function* _getKanbanJobWorks(action) {
  const { payload, callback } = action;
  const {
    groupBy, tenantIds, orgId, status, page, limit, userIds, startDate, endDate, departmentId, searchKeyword, moStatus, resourceId, resourceGroupId,
  } = payload;
  try {
    yield put(JobWorkActions.getJobWorksKanbanLoading(true));
    const jobWorks = yield JobWorkServices.getKanbanJobWorks(groupBy, tenantIds, orgId, status, page, limit, userIds, startDate, endDate, departmentId, searchKeyword, moStatus, resourceId, resourceGroupId);
    if (jobWorks?.success) {
      yield put(JobWorkActions.getJobWorksKanbanSuccess(groupBy, jobWorks?.data));
      if (callback) {
        callback();
      }
      yield put(JobWorkActions.getJobWorksKanbanLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: jobWorks.message,
        duration: 4,
        placement: 'top',
      });
    }
  } catch (error) {
    yield put(JobWorkActions.getJobWorksKanbanLoading( false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(jobWorkActionTypes.GET_JOB_WORK_KANBAN.ERROR, error));
  }
}

function* getKanbanJobWorks() {
  yield takeLatest(jobWorkActionTypes.GET_JOB_WORK_KANBAN.REQUEST, _getKanbanJobWorks);
}

function* _getKanbanJobWorksPage(action) {
  const { payload, callback } = action;
  const {
    groupBy, groupId, scrollType, reset,
  } = payload;
  const state = yield select();
  const groupDetails = state.JobWorkReducers?.kanbanJobWorks?.[groupBy];
  const { filters } = groupDetails;
  try {
    yield put(JobWorkActions.getJobWorksKanbanPageLoading(groupBy, true));
    if (groupBy === 'operator') {
      const groupToUpdate = groupDetails?.job_works?.find((item) => item?.group_name === groupId?.replaceAll('column-', ''));
      const pageUserId = groupToUpdate?.job_works?.[0]?.assignees?.[0]?.user_id || '-1000';
      const count = Number(groupToUpdate?.count);
      const { page, limit, group_name } = groupToUpdate;
      if (count > (limit * page) || reset) {
        const jobWorks = yield JobWorkServices.getKanbanJobWorks(groupBy, filters?.tenant_id, filters?.org_id, filters?.status, reset ? 1 : page + 1, filters?.limit, pageUserId?.toString(), filters?.from_date, filters?.to_date, filters?.department_id, filters?.search_keyword, filters?.mo_status, filters?.resource_id, filters?.resource_group_id);
        if (jobWorks?.success) {
          yield put(JobWorkActions.getJobWorksKanbanPageSuccess(groupBy, jobWorks?.data?.job_works?.filter((item) => item?.group_name?.includes(group_name))?.[0]?.job_works, reset ? 0 : page, reset ? 1 : page + 1, group_name, jobWorks?.data?.job_works?.filter((item) => item?.group_name?.includes(group_name))?.[0]?.count));
          if (callback) {
            callback();
          }
        } else {
          notification.open({
            type: 'error',
            message: jobWorks.message,
            duration: 4,
            placement: 'top',
          });
        }
      }
      yield put(JobWorkActions.getJobWorksKanbanPageLoading(groupBy, false));
    } else if (groupBy === 'machine' || reset) {
      const groupToUpdate = groupDetails?.job_works?.find((item) => item?.group_name === groupId?.replaceAll('column-', ''));
      const pageMachineId = groupToUpdate?.job_works?.[0]?.machine_resource_group?.allocated_machine?.resource_id;
      const count = Number(groupToUpdate?.count);
      const { page, limit, group_name } = groupToUpdate;
      if (count > (limit * page)) {
        const jobWorks = yield JobWorkServices.getKanbanJobWorks(groupBy, filters?.tenant_id, filters?.org_id, filters?.status, page + 1, filters?.limit, filters?.user_id, filters?.from_date, filters?.to_date, filters?.department_id, filters?.search_keyword, filters?.mo_status, pageMachineId, filters?.resource_group_id);
        if (jobWorks?.success) {
          yield put(JobWorkActions.getJobWorksKanbanPageSuccess(groupBy, jobWorks?.data?.job_works?.[0]?.job_works, page, page + 1, group_name, jobWorks?.data?.job_works?.[0]?.count));
          if (callback) {
            callback();
          }
        } else {
          notification.open({
            type: 'error',
            message: jobWorks.message,
            duration: 4,
            placement: 'top',
          });
        }
      }
    } else if (groupBy === 'work_center' || reset) {
      const groupToUpdate = groupDetails?.job_works?.find((item) => item?.group_name === groupId?.replaceAll('column-', ''));
      const pageResourceGroupId = groupToUpdate?.job_works?.[0]?.machine_resource_group?.resource_group_id;
      const count = Number(groupToUpdate?.count);
      const { page, limit, group_name } = groupToUpdate;
      if (count > (limit * page)) {
        const jobWorks = yield JobWorkServices.getKanbanJobWorks(groupBy, filters?.tenant_id, filters?.org_id, filters?.status, page + 1, filters?.limit, filters?.user_id, filters?.from_date, filters?.to_date, filters?.department_id, filters?.search_keyword, filters?.mo_status, filters?.resource_id, pageResourceGroupId);
        if (jobWorks?.success) {
          yield put(JobWorkActions.getJobWorksKanbanPageSuccess(groupBy, jobWorks?.data?.job_works?.[0]?.job_works, page, page + 1, group_name, jobWorks?.data?.job_works?.[0]?.count));
          if (callback) {
            callback();
          }
        } else {
          notification.open({
            type: 'error',
            message: jobWorks.message,
            duration: 4,
            placement: 'top',
          });
        }
      }
    }
    yield put(JobWorkActions.getJobWorksKanbanPageLoading(groupBy, false));
  } catch (error) {
    yield put(JobWorkActions.getJobWorksKanbanPageLoading(groupBy, false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getKanbanJobWorksPage() {
  yield takeEvery(jobWorkActionTypes.GET_JOB_WORK_KANBAN_PAGE.REQUEST, _getKanbanJobWorksPage);
}

function* _processJwMaterial(action) {
  try {
    yield put(JobWorkActions.processJwMaterialLoading(true));
    const {
      payload, callback,
    } = action;
    const response = yield JobWorkServices.processJwMaterial(payload);
    if (response?.success) {
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        placement: 'top',
        type: 'error',
        message: response?.message,
        duration: 4,
      });
    }
    yield put(JobWorkActions.processJwMaterialLoading(false));
  } catch (error) {
    yield put(JobWorkActions.processJwMaterialLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* _processJwMaterialComplete(action) {
  try {
    yield put(JobWorkActions.processJwMaterialCompleteLoading(true));
    const {
      payload, callback,
    } = action;
    const response = yield JobWorkServices.processJwMaterialComplete(payload);
    if (response?.success) {
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        placement: 'top',
        type: 'error',
        message: response?.message,
        duration: 4,
      });
    }
    yield put(JobWorkActions.processJwMaterialCompleteLoading(false));
  } catch (error) {
    yield put(JobWorkActions.processJwMaterialCompleteLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }

}


function* processJwMaterialComplete() {
  yield takeLatest(jobWorkActionTypes.PROCESS_JW_MATERIAL_COMPLETE.REQUEST, _processJwMaterialComplete);
}

function* processJwMaterial() {
  yield takeLatest(jobWorkActionTypes.PROCESS_JW_MATERIAL.REQUEST, _processJwMaterial);
}

/**
 *
 */
export default function* jobWorkSaga() {
  yield all([
    getJobWorks(),
    getJobWorkById(),
    getJobWorkByMoId(),
    updateJobWork(),
    updateJobWorkV2(),
    getJobOperators(),
    getKanbanJobWorks(),
    getKanbanJobWorksPage(),
    processJwMaterial(),
    processJwMaterialComplete(),
  ]);
}
